import { useEffect, useState } from 'react';
import { AssistantLauncher } from '@features/assistant/components/AssistantLauncher.tsx';
import { router } from './router.tsx';

/**
 * Engancha el asistente flotante al router.
 *
 * Existe porque el asistente se monta en `main.tsx`, fuera de `<RouterProvider>`, donde
 * `useLocation` no funciona. Suscribirse al objeto `router` sí funciona y es lo mismo que ya
 * hace `main.tsx` para redirigir al login cuando cae la sesión.
 *
 * Vive en `app/` y no en la feature porque es quien conoce el router: una feature que importara
 * de `app/` invertiría la dirección de las dependencias.
 */
export function AssistantMount() {
  const [pathname, setPathname] = useState(() => router.state.location.pathname);

  useEffect(() => router.subscribe((state) => setPathname(state.location.pathname)), []);

  return (
    <AssistantLauncher
      pathname={pathname}
      onExpand={() => { void router.navigate('/asistente'); }}
    />
  );
}
